import React from 'react';
import './OceanScene.css';
import OctopusLogo from '../OctopusLogo';

export default function OceanScene({ brandLogo, brandName, pending } = {}) {
  return (
    <div className="ocean-scene">
      {/* Ambient color variation */}
      <div className="ocean-ambient" />

      {/* Light caustics from surface */}
      <div className="ocean-caustics" />

      {/* Light rays — all from top-left */}
      <div className="ocean-rays">
        <div className="ocean-ray" />
        <div className="ocean-ray" />
        <div className="ocean-ray" />
        <div className="ocean-ray" />
        <div className="ocean-ray" />
        <div className="ocean-ray" />
      </div>

      {/* Bubbles — behind content */}
      <div className="ocean-bubbles">
        <div className="ocean-bubble" />
        <div className="ocean-bubble" />
        <div className="ocean-bubble" />
        <div className="ocean-bubble" />
        <div className="ocean-bubble" />
        <div className="ocean-bubble" />
        <div className="ocean-bubble" />
        <div className="ocean-bubble" />
      </div>

      {/* Logo + brand text — workspace-branded or default Octopus. While a
          `?ws=` brand is still resolving (`pending`), we render a neutral
          placeholder badge and suppress the wordmark so a branded visitor never
          sees the Octopus flash before their logo loads. */}
      <div className="ocean-octopus">
        {pending ? (
          <div className="h-[140px] w-[140px] animate-pulse rounded-full bg-white/10 p-[3px] shadow-2xl" />
        ) : brandLogo ? (
          <div className="h-[140px] w-[140px] rounded-full p-[3px] bg-gradient-to-br from-secondary to-primary shadow-2xl">
            <div className="h-full w-full rounded-full bg-white flex items-center justify-center overflow-hidden p-4">
              <img
                src={brandLogo}
                alt={brandName || ''}
                className="max-h-full max-w-full object-contain"
              />
            </div>
          </div>
        ) : (
          <OctopusLogo width={280} height={255} />
        )}
        {!pending && (
          <h1
            className={`ocean-brand-text text-4xl tracking-wider pt-3 font-bold bg-gradient-to-r text-transparent bg-clip-text ${
              brandName
                ? 'from-primary to-secondary'
                : 'from-[#FFAE00] to-[#05F555]'
            }`}
          >
            {brandName || 'OCTOPUS'}
          </h1>
        )}
      </div>

      {/* Bubbles — in front of content */}
      <div className="ocean-bubbles-front">
        <div className="ocean-bubble" />
        <div className="ocean-bubble" />
        <div className="ocean-bubble" />
        <div className="ocean-bubble" />
      </div>

      {/* Seabed */}
      <div className="ocean-floor">
        <div className="ocean-floor-sand" />
        <div className="ocean-floor-texture" />
        {/* Rocks */}
        <div className="ocean-rock" />
        <div className="ocean-rock" />
        <div className="ocean-rock" />
        <div className="ocean-rock" />
        <div className="ocean-rock" />
        <div className="ocean-rock" />
        {/* Seaweed clusters */}
        <div className="ocean-seaweed" />
        <div className="ocean-seaweed" />
        <div className="ocean-seaweed" />
        <div className="ocean-seaweed" />
        <div className="ocean-seaweed" />
        <div className="ocean-seaweed" />
        <div className="ocean-seaweed" />
        <div className="ocean-seaweed" />
      </div>
    </div>
  );
}
